import script from "./form-unit-row.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-unit-row.vue?vue&type=script&setup=true&lang=ts"

import "./form-unit-row.vue?vue&type=style&index=0&id=625f9c20&lang=scss"

const __exports__ = script;

export default __exports__